import { LoadingContext } from "../Context";
import { ProfileLayout } from "../Container/Layout";
import React, { useContext, useEffect, useState } from "react";
import { ResponsibleStudent } from "../Structures";
import {
  TransactionGetResponsibleStudents,
  TransactionPostResponsibleStudents,
} from "../Services/Transactions";
import { Toast } from "../Utils";
import { Empty } from "../Components/Base";

const ResPonsibleStudents = () => {
  const { loading, setLoading } = useContext(LoadingContext);

  // ==============================================================================================================

  const [students, setStudents] = useState<ResponsibleStudent[]>([]);

  // ==============================================================================================================

  const handleClickStudentStatus = (studentId: ResponsibleStudent["id"]) => {
    setLoading(true);
    TransactionPostResponsibleStudents({ user_id: studentId.toString() })
      .then(({ data: res }) => {
        if (res.transaction_status) {
          const temp = [...students];
          const student = temp.find((item) => item.id == studentId)!;
          student.verified_by_responsible = !student.verified_by_responsible;
          setStudents(temp);
        }
        Toast(res.transaction_status ? "success" : "error", res.message);
      })
      .finally(() => setLoading(false));
  };

  // ==============================================================================================================

  useEffect(() => {
    setLoading(true);
    TransactionGetResponsibleStudents()
      .then(({ data: res }) => {
        if (res.transaction_status) {
          setStudents(res.data || []);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  // ==============================================================================================================

  return (
    <ProfileLayout>
      <Empty
        data={students}
        isLoading={loading}
        description="در حال حاضر هنرجویی وجود ندارد"
      >
        <div className="card border mb-4">
          <div className="card-header border-bottom p-3">
            <h4 className="card-header-title mb-0">هنرجو ها</h4>
          </div>
          <div className="card-body">
            <div className="d-flex w-100 justify-content-end mt-4">
              <table className="table table-striped table-bordered text-center">
                <thead>
                  <tr>
                    <td scope="col">
                      <span className="mx-1">شناسه</span>
                    </td>
                    <td scope="col">نام</td>
                    <td scope="col">نام‌خانوادگی</td>
                    <td scope="col">شماره تماس</td>
                    <td scope="col">نام پدر</td>
                    <td scope="col">کد ملی</td>
                    <td scope="col">تایید مربی</td>
                    <td scope="col" className="text-center">
                      تایید شده / نشده
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {students.map((student) => (
                    <tr
                      style={{ height: 50, verticalAlign: "middle" }}
                      key={student.id}
                    >
                      <td className="mx-3">
                        <span className="mx-2">{student.id}</span>
                      </td>
                      <td>{student.first_name}</td>
                      <td>{student.last_name}</td>
                      <td>{student.phoneNumber}</td>
                      <td>{student.fatherName}</td>
                      <td>{student.nationalCode}</td>
                      <td>
                        {student.verified_by_coach ? (
                          <i className="bi bi-check-circle-fill text-success fs-5 d-flex justify-content-center align-items-center" />
                        ) : (
                          <i className="bi bi-x-circle-fill text-danger fs-5 d-flex justify-content-center align-items-center" />
                        )}
                      </td>
                      <td>
                        <div className="d-flex  justify-content-center align-items-center gap-3">
                          {student.verified_by_responsible ? (
                            <i className="bi bi-check-circle-fill text-success fs-5 d-flex justify-content-center align-items-center" />
                          ) : (
                            <i className="bi bi-x-circle-fill text-danger fs-5 d-flex justify-content-center align-items-center" />
                          )}
                          <p
                            onClick={() => handleClickStudentStatus(student.id)}
                            className="mb-0 text-primary fw-bold cursor-pointer"
                          >
                            تغییر
                          </p>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Empty>
    </ProfileLayout>
  );
};

export default ResPonsibleStudents;
